import authService from '@/services/auth.service';
import accountsService from '@/services/accounts.service';
import intervenerService from '../services/interveners.service';

/**
 * Si en alguna de las cuentas hay alguna operacicón sin firmar se retorna true, de lo contrario false.
 * @param {*} accounts
 * @returns
 */

const operationsHasDocumentsSigned = async accounts => {
    const config = authService.buildConfigWithHeaders();
    let operationsHasDocsCorrect = true;
    for (let i = 0; i < accounts.length; i++) {
        config.params = {};
        config.params['$limit'] = 'null';
        const res = await accountsService.getAccountOperations(config, accounts[i].uuid);
        const operations = res.data.related_operations;
        operationsHasDocsCorrect = operations.every(operation => {
            return (
                operation.has_docs_signed ||
                operation.has_docs_validated ||
                operation.status === 'SIGNED' ||
                operation.status === 'VALIDATED' ||
                operation.status === 'RD_SENT' ||
                operation.status === 'FINALIZED' ||
                operation.status === 'CANCELLED' ||
                operation.status === 'PERIODIC_ACTIVE'
            );
        });
        if (!operationsHasDocsCorrect) {
            break;
        }
    }
    return operationsHasDocsCorrect;
};

// Comprobar si se han firmado todos los documentos de interviniente, de cuenta y operaciones
export const hasSignedAllDocuments = async (intervener, accounts) => {
    const intervenerHasDocsSigned = intervener.has_docs_signed;
    const intervenerHasDocsValidated = intervener.has_docs_validated;
    const intervenerHasSignedStatus =
        intervener.source_system === 'RD' ||
        intervener.status === 'SIGNED' ||
        intervener.status === 'VALIDATED' ||
        intervener.status === 'RD_SENT' ||
        intervener.status === 'FINALIZED';

    const accountsHasDocsSigned = accounts.every(account => {
        return account.has_docs_signed;
    });
    const accountsHasDocsValidated = accounts.every(account => {
        return account.has_docs_validated;
    });
    const accountsHasSignedStatus = accounts.every(account => {
        return (
            (account.source_system === 'RD' && account.source === 'MIGRACION') ||
            account.status === 'SIGNED' ||
            account.status === 'VALIDATED' ||
            account.status === 'RD_SENT' ||
            account.status === 'FINALIZED'
        );
    });

    const interverHasDocsCorrect =
        intervenerHasDocsSigned || intervenerHasDocsValidated || intervenerHasSignedStatus;
    let accountsHasDocsCorrect =
        accountsHasDocsSigned || accountsHasDocsValidated || accountsHasSignedStatus;
    let opearationsHasDocsCorrect;

    // DOCUMENTO_ACREDITATIVO_TITULARIDAD_CC
    const missingsCCCDocumentsRes = await intervenerService.getMissingCCCDocuments(intervener.uuid);

    const missingsCCCDocuments = missingsCCCDocumentsRes.data.intervener_ccc_documents;

    if (missingsCCCDocuments.some(doc => !doc.is_validated && !doc.is_signed)) {
        accountsHasDocsCorrect = false;
    }

    if (interverHasDocsCorrect && accountsHasDocsCorrect) {
        opearationsHasDocsCorrect = await operationsHasDocumentsSigned(accounts);
    }
    const hasSignedAllDocuments =
        interverHasDocsCorrect && accountsHasDocsCorrect && opearationsHasDocsCorrect;
    return hasSignedAllDocuments;
};
